import { SyntheticEvent, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import createFunction from '../admin/crudFunctions/createFunction'
import { client } from '../interfaces'

const NewClient = () => {
  const [name, setName] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [error, setError] = useState<string>('')
  const history = useHistory()
  const handleSubmit = (e: SyntheticEvent): void => {
    e.preventDefault()
    if (!name || !phone) {
      setError('Debes completar ambos campos')
    } else {
      const endpoint: string = 'client/create'
      const clientObj: client = { name, phone }
      const body: string = JSON.stringify(clientObj)

      createFunction(endpoint, body).then((response: client) => {
        if (response) {
          history.push({
            pathname: '/tecnico/cliente-final',
            state: { success: true }
          })
        } else {
          setError('Existe un cliente con ese telefono')
        }
      })
    }
  }

  return (
    <>
      <div className='container grid justify-items-center md:mx-auto'>
        <div className='w-full bg-viper text-white text-4xl text-center h-20 flex items-center justify-center'>
          Nuevo Cliente
        </div>
        <form className='grid mt-8' onSubmit={handleSubmit}>
          <label htmlFor='name' className='text-2xl'>
            Nombre
          </label>
          <input
            type='text'
            name='name'
            id='name'
            className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-8'
            onChange={(e) => setName(e.target.value)}
          />

          <label htmlFor='phone' className='text-2xl'>
            Teléfono
          </label>
          <input
            type='text'
            name='phone'
            id='phone'
            value={phone}
            placeholder='04241234567'
            className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-16'
            onChange={(e) => setPhone(e.target.value.replace(/\D/, ''))}
          />
          {error && (
            <h2 className='text-center text-xl mb-10 text-red-500'>{error}</h2>
          )}
          <button
            type='submit'
            className='bg-black active:bg-gray-800 rounded-full h-14 w-80 text-center text-white text-3xl mb-60'>
            Guardar
          </button>
        </form>
        <Link to='/tecnico/panel'>
          <button
            type='button'
            className='border-solid border-2 border-black rounded-full h-14 w-80 text-center text-3xl'>
            Atrás
          </button>
        </Link>
      </div>
    </>
  )
}

export default NewClient
